// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecParserError = void 0;
class SpecParserError extends Error {
    constructor(message, errorType) {
        super(message);
        this.errorType = errorType;
    }
}
exports.SpecParserError = SpecParserError;
//# sourceMappingURL=specParserError.js.map